export default __webpack_public_path__ + "static/about-us-04-df383843af3fcda060ee4254e880bb5c.jpg";